import register from '../../../../global/js/registry';
export default register('m-login-form', () => import(/* webpackMode: "lazy" */ './m-login-form.controller'));
